import * as React from 'react';
import './Beach.scss';

import { AppProps, BeachRootState } from '../index';
import { Route, Routes } from 'react-router';
import {
  useFixedHeader
} from '../utils';
import BeachMatchSeriesOverview from './beach-match-series-overview/BeachMatchSeriesOverview';
import BeachMatchesOverview from './beach-matches-overview/BeachMatchesOverview';
import MatchFilter from '../match-filter/MatchFilter';
import { connect } from 'react-redux';

interface OwnProps {
  appProps: AppProps
}

const mapStateToProps = (state: BeachRootState) => {

  return {
    matchDays: state.tickerState.matchDays,
    matchSeries: state.tickerState.matchSeries,
    matchStatesByUuid: state.tickerState.matchStatesByUuid,
    settings: state.tickerState.settings,
    loading: state.tickerState.loading,
    error: state.tickerState.error,
    activeFilterDay: state.dayFilter.activeFilterDay,
    favorites: state.favorites,
    associations: state.tickerState.associations
  }
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps

const BeachView = (props: Props) => {

    const {
      appProps,
      loading
    } = props

    const { isFixed, ref } = useFixedHeader()

    const matchDays = props.matchDays

    return (
      <div className={'BeachView ' + (isFixed ? 'header-fixed' : '')}>
        <div className="OverviewHeader" ref={ref}>
          <div className="App-title">{appProps.appTitle}</div>
          {!loading && <MatchFilter matchDays={matchDays} />}
        </div>
        <Routes>
          <Route path={"/hierarchies/:hierarchyId/matchseries/:matchseriesId"} element={<BeachMatchesOverview appProps={appProps}/>}></Route>
          <Route path={"/hierarchies/:hierarchyId"} element={<BeachMatchSeriesOverview/>}></Route>
          <Route path={"/favorites"} element={<BeachMatchesOverview favoritesRoute={true} appProps={appProps}/>}/>
          <Route path={"/*"} element={ <BeachMatchSeriesOverview /> }/>
        </Routes> 
      </div>
    )

}

export default connect(mapStateToProps)(BeachView)
